import type { PostTripDefect } from '@chukua/common';
import { Tag } from 'antd';

const SEVERITY_TAGS: Record<PostTripDefect['severity'], { label: string; color: string; order: string }> = {
  unsafe: { label: 'Unsafe', color: 'error', order: 'critical work order, truck off the road' },
  major: { label: 'Major', color: 'warning', order: 'scheduled work order' },
  minor: { label: 'Minor', color: 'default', order: 'work order to monitor' },
};

/** What the driver found, read-only. Each becomes a work order when the truck is received, which the line under it says. */
export function DefectList({ defects }: { defects: PostTripDefect[] }) {
  if (defects.length === 0) return null;
  return (
    <section aria-labelledby="defects-heading" className="rounded-xl border border-line bg-surface p-4">
      <h2 id="defects-heading" className="mb-3 text-base font-semibold text-fg">
        Defects found ({defects.length})
      </h2>
      <ul className="flex flex-col gap-3">
        {defects.map((defect) => {
          const tag = SEVERITY_TAGS[defect.severity];
          return (
            <li key={defect.id} className="flex flex-col gap-1 border-t border-line pt-3 first:border-0 first:pt-0">
              <div className="flex items-center gap-2">
                <Tag color={tag.color} className="m-0">
                  {tag.label}
                </Tag>
                <span className="text-sm font-medium text-fg capitalize">{defect.area}</span>
              </div>
              <p className="text-sm text-fg">{defect.description}</p>
              <p className="text-xs text-muted">Becomes a {tag.order}.</p>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
